import axios from 'axios';

import { baseURL } from 'constants/urls';

const axiosClient = axios.create({
  baseURL,
});

export default axiosClient;
